export const HEADERS = {
    ACCEPT: 'Accept',
    CONTENT_TYPE: 'Content-Type',
    CONTENT_LENGTH: 'Content-Length',
};

export const ERROR_CODES = {
    CONNECTION_ABORTED: 'ECONNABORTED',
    CONNECTION_RESET: 'ECONNRESET',
    CONNECTION_REFUSED: 'ECONNREFUSED',
};

// Only use methods supported by CloudFront:
// https://docs.aws.amazon.com/cloudfront/latest/APIReference/API_AllowedMethods.html
export const METHODS = {
    GET: 'get',
    POST: 'post',
    PUT: 'put',
    DELETE: 'delete',
    OPTIONS: 'options',
};

// NOTE: custom tokens shouldn't include dots "."
export const CUSTOM_HTTP_HEADERS = {
    PERMISSION_TOKENS: 'milanote-com-permission-tokens',
    NO_THROTTLE: 'milanote-com-no-throttle',

    // Used to switch to a custom version of the API
    API_FEATURE: 'milanote-com-api-feature',

    // Used so the server can give hints to the client about how long the data is valid for
    DATA_EXPIRY: 'milanote-com-data-expiry',
    DATA_FETCHED_TIME: 'milanote-com-data-fetched-time',
};
